<template>
    <div v-if="user !== null">
        <div class="vc-campaign">
            <h1 class="vc-register-title">
                <span>{{ $locale.appName }}海外オンライン医療相談サービス</span><!--
             --><span>{{ planName ? planName :user.plan.common_name }}{{ isOrganization ? '' : '申込みフォーム' }}</span>
            </h1>
        </div>

        <div class="card">
            <div class="card-header">{{ isOrganization ? 'ドクターパス利用情報' : '申込み情報の入力' }}</div>
            <div class="card-body">
                <div class="row">

                    <div class="col-12 col-md-6 mb-3">
                        <label
                            for="last_name_kana"
                            class="is-required-ja">
                            姓
                        </label>
                        <input
                            v-model="user.last_name"
                            type="text"
                            id="last_name_kana"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.last_name }"
                            placeholder="海外"
                            readonly>
                        <div
                            v-if="errors.last_name"
                            class="invalid-feedback d-block">
                            {{ errors.last_name[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-6 mb-3">
                        <label
                            for="first_name_kana"
                            class="is-required-ja">
                            名
                        </label>
                        <input
                            v-model="user.first_name"
                            type="text"
                            id="first_name_kana"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.first_name }"
                            placeholder="太郎"
                            readonly>
                        <div
                            v-if="errors.first_name"
                            class="invalid-feedback d-block">
                            {{ errors.first_name[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-6 mb-3">
                        <label
                            for="last_name_kana"
                            class="is-required-ja">
                            姓（フリガナ）
                        </label>
                        <input
                            v-model="user.last_name_kana"
                            type="text"
                            id="last_name_kana"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.last_name_kana }"
                            placeholder="カイガイ"
                            readonly>
                        <div
                            v-if="errors.last_name_kana"
                            class="invalid-feedback d-block">
                            {{ errors.last_name_kana[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-6 mb-3">
                        <label
                            for="first_name_kana"
                            class="is-required-ja">
                            名（フリガナ）
                        </label>
                        <input
                            v-model="user.first_name_kana"
                            type="text"
                            id="first_name_kana"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.first_name_kana }"
                            placeholder="タロウ"
                            readonly>
                        <div
                            v-if="errors.first_name_kana"
                            class="invalid-feedback d-block">
                            {{ errors.first_name_kana[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group mb-1 pb-1 mb-3">
                            <label for="edit_email" class="is-required-ja">メールアドレス</label>
                            <input v-model="user.email"
                                id="edit_email"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.email }"
                                type="text"
                                placeholder="メールアドレス"
                                readonly>
                            <div
                                class="invalid-feedback d-block mt-1"
                                v-if="errors.email">
                                {{ errors.email[0] }}
                            </div>
                        </div>
                    </div>
                
                    <template v-if="!isOrganization">
                        <div class="col-12">
                            <div class="form-group m-form__group">
                                <label
                                    for="purpose"
                                    class="is-required-ja">
                                    渡航目的
                                </label>
                                <input
                                    v-model="purpose"
                                    type="text"
                                    name="purpose"
                                    id="purpose"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.purpose }"
                                    placeholder="渡航目的を入力してください（例: 観光）"
                                    :readonly="isStudyAbroadPlan">
                                <div
                                    v-if="errors.purpose"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.purpose[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group m-form__group">
                                <label
                                    for="destination"
                                    class="is-required-ja">
                                    目的地
                                </label>
                                <input
                                    v-model="destination"
                                    type="text"
                                    name="destination"
                                    id="destination"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.destination }"
                                    placeholder="目的地を入力してください（例: ニューヨーク）">
                                <div
                                    v-if="errors.destination"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.destination[0] }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="col-12 flatpickrWrapper">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">
                                <span class="u-palt">出国日</span>
                                <span class="text-muted u-palt">（日本時間）</span>
                            </label>
                            <flat-pickr
                                v-model="periodStart"
                                :config="flatPickrConfig.periodStart"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.period_start, 'readonly' : !!fixedPeriodStart }"
                                placeholder="選択してください"/>
                            <div
                                v-if="errors.period_start"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.period_start[0] }}
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="isCyclePlan"
                        class="col-12">
                        <div class="form-group m-form__group">
                            <label for="period_schedule">
                                <span class="d-block is-required-ja-self">留学予定期間</span>
                                <span class="d-block small text-muted">おおよその期間で構いませんのでご入力をお願いします。</span>
                            </label>
                            <input
                                v-model="periodSchedule"
                                type="text"
                                name="period_schedule"
                                id="period_schedule"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.period_schedule }"
                                placeholder="留学予定期間を入力してください（例: 4月〜9月まで）">
                            <div
                                v-if="errors.period_schedule"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.period_schedule[0] }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        class="col-12 flatpickrWrapper">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">
                                <span class="u-palt">帰国日</span>
                                <span class="text-muted u-palt">（日本時間）</span>
                            </label>
                            <flat-pickr
                                v-model="periodEnd"
                                :config="flatPickrConfig.periodEnd"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.period_end, 'readonly' : !!fixedPeriodEnd }"
                                placeholder="選択してください"/>
                            <div
                                v-if="errors.period_end"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.period_end[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="isStepCompleted && isBillingPersonal">
            <div v-if="!canSkipPayment && isFetchedCard"  class="mt-3">
                <div
                    v-if="card === null"
                    class="alert alert-warning">
                    {{ $locale.appName }}をご利⽤いただくには、クレジットカードを登録する必要があります。<br>
                    クレジットカードを登録し、下記料⾦のお⽀払いが完了すると利⽤開始されます。
                </div>
                <div
                    v-else
                    class="alert alert-success">
                    クレジットカードご登録済みです。<br>
                    下記料⾦のお⽀払いが完了すると、{{ $locale.appName }}の利⽤が開始されます。
                </div>
            </div>

            <div v-if="!canSkipPayment && isFetchedCard" class="mt-3">
                <template v-if="card === null">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div style="margin-top: 2px;">クレジットカード登録</div>
                        </div>

                        <div class="card-body">
                            <form @submit.stop.prevent="storeCreditCard">
                                <div class="form-group">
                                    <label>カード番号</label>
                                    <div id="el-card-number"></div>
                                </div>

                                <div class="form-group">
                                    <label>有効期限</label>
                                    <div id="el-card-expiry"></div>
                                </div>

                                <div class="form-group">
                                    <label>カード名義</label>
                                    <input
                                        v-model="name"
                                        id="name"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors.name }"
                                        type="text"
                                        :placeholder="`${$locale.appName} TARO`">
                                    <div v-if="errors.name" class="invalid-feedback d-block mt-1">
                                        {{ errors.name[0] }}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>セキュリティコード</label>
                                    <div id="el-card-cvc"></div>
                                </div>

                                <div v-if="errors.message"
                                     class="invalid-feedback d-block">
                                    {{ errors.message[0] }}
                                </div>

                                <div class="d-flex justify-content-end">
                                    <button
                                        :disabled="inProgress"
                                        :class="{ 'btn-yokumiru-gray' : inProgress }"
                                        class="vc-button-credit btn btn-yokumiru-orange">
                                        {{ inProgress ? '処理中です…' : '登録' }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div
                        class="card"
                        :class="{ 'is-invalid' : errors.stripe }">
                        <div class="card-header d-flex justify-content-between">
                            <div style="margin-top: 2px;">登録中のクレジットカード</div>
                            <b-button
                                size="sm"
                                variant="yokumiru-gray"
                                @click="openModalDestroyCreditCard">
                                削除
                            </b-button>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-3">カード番号</div>
                                <div class="col-12 col-md-9">{{ `**** **** ${card.last4}` }}</div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-12 col-md-3">有効期限</div>
                                <div class="col-12 col-md-9">{{ `${card.exp_year}年${card.exp_month}月` }}</div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-12 col-md-3">カード名義</div>
                                <div class="col-12 col-md-9">{{ card.name }}</div>
                            </div>
                        </div>
                    </div>
                </template>

                <div
                    v-if="errors.stripe"
                    class="stripeError invalid-feedback d-flex justify-content-center mt-2 mb-3">
                    <div v-if="errors.stripe.code === 'card_declined'">カード会社によって支払いが拒否されました。</div>
                    <div v-else-if="errors.stripe.type === 'card_error'">このカードは利用できません。</div>
                    <div v-else-if="errors.stripe.message === 'Invoice is already paid'">既に支払い済みの請求書です。</div>
                    <div v-else-if="['api_connection_error', 'api_error'].includes(errors.stripe.type)">
                        決済システムのメンテナンス中です。時間を置いて再度お試しください。
                    </div>
                </div>
            </div>

            <div v-if="userCoupon" class="mt-3">
                <div
                    v-if="discount > 0"
                    class="card"
                    :class="{ 'is-invalid' : errors.user_coupon_id }">
                    <div class="card-header d-flex justify-content-between">
                        <div style="margin-top: 2px;">クーポンの適用</div>
                    </div>

                    <div class="card-body">
                        <div v-if="userCoupon.coupon_code !== null">
                            {{ `クーポンコード: ${userCoupon.coupon_code.code}` }}
                        </div>
                        <div>
                            <span>{{ userCoupon.name }}</span><!--
                         --><span class="text-muted">{{ `（${discountMethod}）` }}</span>
                        </div>
                    </div>
                </div>
                <div
                    v-if="errors.user_coupon_id"
                    class="invalid-feedback d-block mt-1">
                    {{ errors.user_coupon_id[0] }}
                </div>
            </div>
            <div v-else-if="isBillingPersonal" class="mt-3">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div style="margin-top: 2px;">クーポンコードの入力</div>
                    </div>

                    <div class="card-body">
                        <user-coupon-code-form
                            :coupon-code="couponCode"
                            :plan-key="planKey"
                            is-option>
                        </user-coupon-code-form>
                    </div>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header">ご請求内容</div>
                <div class="card-body">
                    <p class="font-weight-bold mb-2">{{ planName ? planName :user.plan.common_name }}</p>

                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <div>{{ pStartDisplay }}&nbsp;〜&nbsp;{{ pEndDisplay }}（日本時間）</div>
                            <div
                                v-if="cycleWillUpdate !== null"
                                class="text-success">
                                {{ `${cycleWillUpdate} に自動更新予定` }}
                            </div>
                        </div>
                        <div class="text-muted">
                            <span>{{ subtotal.toLocaleString() }}</span>
                            <span class="small">円</span>
                        </div>
                    </div>

                    <template v-if="userCoupon && discount > 0">
                        <hr style="margin: 5px;">

                        <div class="d-flex justify-content-between align-items-center">
                            <div>{{ userCoupon.name }}</div>
                            <div class="text-muted">
                                <span>{{ `-${discount.toLocaleString()}` }}</span>
                                <span class="small">円</span>
                            </div>
                        </div>
                    </template>

                    <hr style="margin: 5px;">

                    <div class="d-flex justify-content-end align-items-baseline mt-3">
                        <div>合計:&nbsp;</div>
                        <div class="vc-total">
                            <span class="font-weight-bold">{{ total.toLocaleString() }}</span>
                            <span class="small font-weight-bold">円</span>
                        </div>
                        <div class="u-palt small font-weight-bold">&nbsp;（税込）</div>
                    </div>
                    <div class="d-flex justify-content-end align-items-baseline">
                        <div class="text-muted small">
                            <span v-if="isBillingPersonal">お支払い方法: {{ creditText }}</span>
                            <span v-else>お支払い方法: {{ invoiceLaterText }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center mt-4 mb-5">
            <div>
                <div class="d-flex justify-content-center text-center">
                    <p class="termText">
                        <a :href="user.plan.term_url" target="_blank">{{ planName ? planName :user.plan.common_name }}利用特約</a>をご確認のうえ、同意してからボタンを押してください。
                    </p>
                </div>

                <div class="d-flex justify-content-center mb-4">
                    <div class="form-check">
                        <input
                            v-model="agreement.term"
                            value="1"
                            id="agreement_term"
                            class="form-check-input"
                            type="checkbox">
                        <label
                            for="agreement_term"
                            style="cursor: pointer;">
                            <span class="u-palt">{{ planName ? planName :user.plan.common_name }}利用特約に同意する</span><!--
                         --><span class="u-palt" style="color: #dc3545; font-size: 12px;">&nbsp;（必須）</span>
                        </label>
                    </div>
                </div>

                <div class="text-center">
                    <b-button
                        class="vc-button-payment"
                        :disabled="!isValid"
                        :variant="!isValid ? 'yokumiru-gray' : 'yokumiru-orange'"
                        @click="onSubmit">
                        <span v-if="inProgress">処理中です…</span>
                        <span v-else-if="isOrganization">利用する</span>
                        <span v-else>{{ `${planName ? planName :user.plan.common_name}を申し込む` }}</span>
                    </b-button>
                </div>
            </div>
        </div>

        <destroy-credit-card-modal/>
    </div>
</template>

<script>
    import moment from 'moment-timezone'
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'
    import { loadStripe } from '@stripe/stripe-js'
    import flatPickr from 'vue-flatpickr-component'
    import { Japanese } from 'flatpickr/dist/l10n/ja.js'
    import { mapMutations } from 'vuex'

    export default {
        components: {
            flatPickr,
        },

        props: {
            pubkey: {
                type: String,
                required: true,
            },
            fixedPeriodStart: {
                type: String,
                default: null,
            },
            fixedPeriodEnd: {
                type: String,
                default: null,
            },
            planKey: {
                type: String,
                default: null,
            },
            planName: {
                type: String,
                default: null,
            },
        },

        data: function () {
            return {
                inProgress :false,
                helper: YokumiruHelper,
                cycleUnits: constants.cycleUnits,
                creditText: constants.payment_methods.creditText,
                invoiceLaterText: constants.payment_methods.invoiceLaterText,
                user: null,
                purpose: null,
                destination: null,
                periodStart: null,
                periodEnd: null,
                periodSchedule: null,
                // uploadImage: {
                //     name: null,
                //     object: null,
                //     base64: null,
                // },
                card: null,
                isFetchedCard: false,
                stripe: null,
                elements: null,
                name: null,
                cardNumber: null,
                cardExpiry: null,
                cardCvc: null,
                intent: null,
                errors: {},
                flatPickrCalendarTimer: null,
                agreement: {
                    term: false,
                },
            }
        },

        computed: {
            flatPickrConfig: function () {
                let to = moment().subtract(1, 'days').format('YYYY-MM-DD')

                if (this.fixedPeriodStart && this.periodStart) {
                    to = moment(this.periodStart).subtract(1, 'days').format('YYYY-MM-DD')
                }

                return {
                    periodStart: {
                        locale: Japanese,
                        disable: [{
                            from: '0000-01-01',
                            to: to,
                        }],
                    },
                    periodEnd: {
                        locale: Japanese,
                        disable: [{
                            from: '0000-01-01',
                            to: to,
                        }],
                    },
                }
            },

            /**
             * 旅行情報の入力が完了済みかどうか
             * @return {boolean}
             */
            isStepCompleted: function () {
                if (this.isOrganization) {
                    return this.periodStart
                        && this.periodEnd
                }
                else if (this.isCyclePlan) {
                    return this.purpose
                        && this.destination
                        && this.periodStart
                        && this.periodSchedule
                }

                return this.purpose
                    && this.destination
                    && this.periodStart
                    && this.periodEnd
            },

            /**
             * 団体会員かどうか
             * @return {boolean}
             */
            isOrganization: function () {
                if (!this.user) return false
                return this.user.is_organization
            },

            /**
             * 会員登録時のクーポンコードを返す
             * @return {string|null}
             */
            couponCode: function () {
                if (!this.user || !this.user.coupon_code || this.user.coupon_code.category !== constants.couponCategory.plan) {
                    return null
                }
                return this.user.coupon_code
            },

            /**
             * プランで利用可能なクーポンを返す
             * @return {object|null}
             */
            userCoupon: function () {
                if (!this.user) return null

                return this.user.user_coupons.find((coupon) => {
                    return coupon.category === constants.couponCategory.plan &&
                        (!coupon.has_plan || coupon.plans.some((plan) => plan.id === this.user.plan_id))
                })
            },

            /**
             * 割引方式を返す
             * @return {string}
             */
            discountMethod: function () {
                if (!this.userCoupon) return ''

                const discount = this.userCoupon.discount.toLocaleString()

                if (this.userCoupon.discount_unit === 'percent') {
                    return `${discount}% 割引`
                }
                else if (this.userCoupon.discount_unit === 'static') {
                    return `${discount}円 割引`
                }
                else if (this.userCoupon.discount_unit === 'daily') {
                    return `${discount}円/日 割引`
                }
                return ''
            },

            /**
             * 入力項目の検証がOKかどうか
             * @return {boolean}
             */
            isValid: function () {
                if (this.isBillingPersonal) {
                    if (!this.isStepCompleted || this.inProgress || !this.agreement.term) {
                        return false
                    }
                    return this.card !== null || this.canSkipPayment
                }

                return this.isOrganization && this.agreement.term
            },

            /**
             * 請求サイクルを持つプランかどうか
             * @return {boolean}
             */
            isCyclePlan: function () {
                if (!this.user) return false
                return this.helper.isCyclePlan(this.user.plan)
            },

            /**
             * プランが「留学ドクターパス」かどうか（無料版を含む）
             * @return {boolean}
             */
            isStudyAbroadPlan: function () {
                if (!this.user) return false
                return this.helper.isStudyAbroadPlan(this.user.plan)
            },

            /**
             * 課金対象が個人かどうか
             * @return {boolean}
             */
            isBillingPersonal: function () {
                return this.helper.isBillingPersonal(this.user)
            },

            /**
             * 小計
             * @return {number}
             */
            subtotal: function () {
                if (!this.user) return 0

                return this.user.plan.price * this.cycle
            },

            /**
             * 割引
             * @return {number}
             */
            discount: function () {
                if (!this.userCoupon) {
                    return 0
                }

                let d = 0
                if (this.userCoupon.discount_unit === 'percent') {
                    d = this.subtotal * this.userCoupon.discount / 100
                }
                else if (this.userCoupon.discount_unit === 'static') {
                    d = this.userCoupon.discount
                }
                else if (this.userCoupon.discount_unit === 'daily') {
                    d = this.userCoupon.discount * this.cycle
                }
                return d >= this.subtotal ? this.subtotal : d
            },

            /**
             * 小計 - 割引
             * @return {number}
             */
            subtotalWithDiscount: function () {
                return this.subtotal - this.discount
            },

            /**
             * 初回請求額
             * @return {number}
             */
            total: function () {
                return this.helper.inTax(this.subtotalWithDiscount)
            },

            /**
             * 支払いをスキップ可能かどうか
             * @return {boolean}
             */
            canSkipPayment: function () {
                // 無料 or 課金対象が個人ではない
                return this.total <= 0 || !this.isBillingPersonal
            },

            /**
             * 利用開始日が当日かどうか
             * @return {boolean}
             */
            isStartToday: function () {
                if (!this.periodStart) return false

                return moment().isSameOrAfter(moment(this.periodStart).startOf('day'))
            },

            /**
             * 利用開始日
             * @return {moment.Moment}
             */
            pStart: function () {
                if (!this.user || !this.periodStart) {
                    return null
                }

                if (this.helper.isCyclePlan(this.user.plan) && this.isStartToday) {
                    return moment(`${this.periodStart} ${moment().format('HH:mm:ss')}`)
                }
                return moment(this.periodStart).startOf('day')
            },

            /**
             * 利用終了日
             * @return {moment.Moment}
             */
            pEnd: function () {
                if (!this.user || !this.periodEnd) {
                    return null
                }

                if (this.helper.isCyclePlan(this.user.plan) && this.isStartToday) {
                    return moment(`${this.periodEnd} ${moment().format('HH:mm:ss')}`)
                }
                return moment(this.periodEnd).endOf('day')
            },

            /**
             * 滞在日数
             * @return {number}
             */
            cycle: function () {
                if (this.user.plan.cycle_unit === this.cycleUnits.daily) {
                    if (!this.pStart || !this.pEnd) {
                        return 0
                    }
                    return Math.abs(this.pEnd.clone().add(1, 'second').diff(this.pStart, 'days'))
                }
                else if (this.user.plan.cycle_unit === this.cycleUnits.monthly) {
                    return 1
                }
                return 0
            },

            /**
             * 利用開始日（表示用）
             * @return {string|null}
             */
            pStartDisplay: function () {
                if (!this.user || !this.pStart) {
                  return null
                }

                if (this.helper.isCyclePlan(this.user.plan)) {
                    return this.pStart.clone().format('YYYY年M月D日 HH:mm')
                }
                return this.pStart.clone().format('YYYY年M月D日')
            },

            /**
             * 利用終了日（表示用）
             * @return {string|null}
             */
            pEndDisplay: function () {
                if (!this.user) return null

                if (this.helper.isCyclePlan(this.user.plan)) {
                    if (!this.pStart) return null
                    return this.pStart.clone().add(1, 'months').subtract(1, 'seconds').format('YYYY年M月D日 HH:mm')
                }

                if (!this.pEnd) return null
                return this.pEnd.clone().format('YYYY年M月D日')
            },

            /**
             * 自動更新日
             * @return {string|null}
             */
            cycleWillUpdate: function () {
                if (!this.user) return null
                if (!this.helper.isCyclePlan(this.user.plan)) return null
                if (!this.pStart) return null

                return this.pStart.clone().add(1, 'months').format('YYYY年M月D日')
            },
        },

        watch: {
            isStepCompleted: function () {
                if (this.isStepCompleted) {
                    this.fetchCreditCard()
                }
            },
        },

        created: async function () {
            await this.fetchMe()

            if (this.isStudyAbroadPlan) {
                this.purpose = '留学'
            }
            this.periodStart = this.fixedPeriodStart
            this.periodEnd = this.fixedPeriodEnd

            bus.$on('credit-card-destroyed', this.clearCreditCard)
            bus.$on('user-coupon-published', this.fetchMe)
        },

        beforeDestroy: function () {
            bus.$off('credit-card-destroyed')
            bus.$off('user-coupon-published')
        },

        mounted: function () {
            if (this.fixedPeriodStart && this.fixedPeriodEnd) {
                // 出国日・帰国日が固定されている場合は flatpickr のカレンダーを隠す
                // @see https://github.com/sewii/Yokumiru/issues/687
                this.flatPickrCalendarTimer = setInterval(() => {
                    const elems = document.querySelectorAll('div.flatpickr-calendar')
                    if (elems.length > 0) {
                        elems.forEach((elem) => elem.classList.add('d-none'))
                        clearInterval(this.flatPickrCalendarTimer)
                    }
                }, 500)
            }

            if (this.$store.state.userMode.redirectMessage && this.$store.state.userMode.redirectMessageType) {
                const message = this.$store.state.userMode.redirectMessage
                const type = this.$store.state.userMode.redirectMessageType
                bus.$emit(`alert-${type}`, message)
                this.setRedirectMessage(null)
                this.setRedirectMessageType(null)
            }
            // @todo 以降のアラートは redirectMessage に置き換える
            else if (this.$store.state.userMode.isResetPassword) {
                // 初回ログイン時のパスワード更新後アラート
                this.setIsResetPassword(false)
                bus.$emit('alert-info', '初回ログイン設定が完了しました。')
            }
        },

        methods: {
            ...mapMutations({
                setRedirectMessage: 'userMode/setRedirectMessage',
                setRedirectMessageType: 'userMode/setRedirectMessageType',
                setIsResetPassword: 'userMode/setIsResetPassword',
                setIsSubscriptionStarted: 'userMode/setIsSubscriptionStarted',
            }),

            /**
             * Stripe Elements の初期化
             */
            initStripeElements: async function() {
                this.elements = this.stripe.elements({locale: "ja"})

                this.cardNumber = this.elements.create('cardNumber', {
                    classes: {base: 'StripeElement form-control form-control--stripe'},
                    showIcon: true,
                })
                this.cardExpiry = this.elements.create('cardExpiry', {
                    classes: {base: 'StripeElement form-control form-control--stripe'},
                })
                this.cardCvc = this.elements.create('cardCvc', {
                    classes: {base: 'StripeElement form-control form-control--stripe'},
                })

                setTimeout(() => {
                    this.cardNumber.mount('#el-card-number')
                    this.cardExpiry.mount('#el-card-expiry')
                    this.cardCvc.mount('#el-card-cvc')
                }, 300)
            },

            /**
             * ログインユーザ取得
             */
            fetchMe: function () {
                let endpoint = constants.user.me.endpoint.base
                if (this.planKey) {
                    endpoint = `${endpoint}?plan_key=${this.planKey}`

                }
                return axios.get(endpoint)
                    .then(({data}) => {
                        this.user = data.data
                    })
            },

            /**
             * カード取得
             */
            fetchCreditCard: async function () {
                if (this.canSkipPayment || this.isFetchedCard) {
                    this.isFetchedCard = true
                    return
                }

                this.stripe = await loadStripe(this.pubkey, { locale: "ja" })

                await axios.get(constants.user.credit_cards.endpoint.base)
                    .then(({data}) => {
                        this.card = data.data
                        this.isFetchedCard = true

                        if (!this.card) {
                            this.initStripeElements()
                        }
                    })
            },

            /**
             * 登録完了後のカード再取得
             *
             * @param {string} pm_id
             */
            fetchCreditCardByPaymentMethod: function (pm_id) {
                axios.get(`${constants.user.credit_cards.endpoint.base}/${pm_id}`)
                    .then(({data}) => {
                        this.card = data.data
                    })
            },

            /**
             * カード保存
             */
            storeCreditCard: async function () {
                if (this.inProgress) return
                this.inProgress = true
                this.errors = {}

                if (!this.intent) {
                    await axios.get(constants.user.credit_cards.endpoint.setup_intent)
                        .then(({data}) => {
                            this.intent = data.data
                        })
                }

                this.stripe
                    .confirmCardSetup(this.intent.client_secret, {
                        payment_method: {
                            card: this.elements.getElement('cardNumber'),
                            billing_details: {
                                name: this.name,
                            },
                        },
                    })
                    .then(result => {
                        if (result.setupIntent && result.setupIntent.status === "succeeded") {
                            this.clearSetupCardState()
                            this.fetchCreditCardByPaymentMethod(result.setupIntent.payment_method)
                            bus.$emit('alert-success', 'カードを登録しました。')
                            this.inProgress = false
                        }
                        else {
                            this.errors.message = [result.error.message]
                            this.inProgress = false
                        }
                    })
            },

            /**
             * カード情報入力状態の初期化
             */
            clearSetupCardState: function () {
                this.intent = null
                this.cardNumber.clear()
                this.cardExpiry.clear()
                this.cardCvc.clear()
                this.name = null
            },

            /**
             * カード登録状態を初期化
             */
            clearCreditCard: function () {
                if (this.canSkipPayment) return

                this.errors = {}
                this.card = null
                this.initStripeElements()
            },

            /**
             * カード削除モーダル表示
             */
            openModalDestroyCreditCard: function () {
                bus.$emit('open-modal-destroy-credit-card', this.card)
            },

            /**
             * 利用開始ボタン押下時
             */
            onSubmit: function () {
                if (this.inProgress) return
                this.inProgress = true
                this.errors = {}

                let redirectPath = '/home'
                const req = this.prepareRequest()
                const endpoint = `${constants.user.subscriptions.endpoint.base}/start`

                axios.post(endpoint, req.formData, req.config)
                    .then(({data}) => {
                        if (data.data.client_secret === null) {
                            this.setIsSubscriptionStarted(true)
                            window.location.href = redirectPath
                        }
                        else {
                            // 3DS認証フロー
                            // @see https://github.com/sewii/Yokumiru/issues/987
                            this.stripe
                                .confirmCardPayment(data.data.client_secret, {
                                    payment_method: data.data.payment_method,
                                })
                                .then(async (result) => {
                                    if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                                        let isSynced = false
                                        const sleep = (time) => new Promise((r) => setTimeout(r, time))

                                        // Stripe Webhook (invoice.payment_succeeded) 経由で Subscription モデルが restore されるまで待機
                                        while (!isSynced) {
                                            await sleep(500)
                                            await axios.get(constants.user.me.endpoint.base).then(({data}) => {
                                                isSynced = !!data.data.subscription
                                            })
                                        }
                                        this.setIsSubscriptionStarted(true)
                                        window.location.href = redirectPath
                                    }
                                    else {
                                        bus.$emit('alert-danger', '3Dセキュア認証がキャンセルされました。')
                                        this.inProgress = false
                                    }
                                })
                        }
                    })
                    .catch(({response}) => {
                        if (
                            response
                            && response.hasOwnProperty('data')
                            && response.data
                            && response.data.hasOwnProperty('errors')
                            && response.data.errors
                        ) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger', '利用を開始できませんでした。エラー内容をご確認ください。')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。サポートセンターまでお問い合わせください。')
                        }
                        this.inProgress = false
                    })
            },

            /**
             * 利用開始リクエスト準備
             *
             * @return {Object}
             */
            prepareRequest: function () {
                let formData = new FormData()

                formData.append('period_start', moment(this.periodStart).format('YYYY-MM-DD'))

                if (!this.isOrganization) {
                    formData.append('purpose', this.purpose)
                    formData.append('destination', this.destination)
                }

                if (this.isCyclePlan) {
                    formData.append('period_schedule', this.periodSchedule)
                }
                else {
                    formData.append('period_end', moment(this.periodEnd).format('YYYY-MM-DD'))
                }

                if (this.userCoupon) {
                    formData.append('user_coupon_id', this.userCoupon.id)
                }

                if (this.planKey) {
                    formData.append('plan_key', this.planKey)
                }
                
                return {
                    formData: formData,
                    config: {
                        headers: { 'content-type': 'multipart/form-data' },
                    },
                }
            },

            /**
             * ファイル選択時処理
             *
             * @return {void}
             */
            // bindSelectedImage: function(e) {
            //     const elem = e.target
            //     this.errors = {}

            //     if (elem.files.length > 0) {
            //         if (elem.files[0].size > 10485760) {
            //             this.errors = { file: ['ファイルサイズは10MB以内にしてください。'] }
            //             setTimeout(() => this.initImage(), 100)
            //             return
            //         }

            //         this.uploadImage.object = elem.files[0]
            //         this.uploadImage.name = this.uploadImage.object.name

            //         if (elem.files[0].type !== 'application/pdf') {
            //             const fr = new FileReader()
            //             fr.onload = () => { this.uploadImage.base64 = fr.result }
            //             fr.readAsDataURL(this.uploadImage.object)
            //         } else {
            //             this.uploadImage.base64 = null
            //         }
            //     } else {
            //         this.initImage()
            //     }
            // },

            /**
             * 状態初期化
             */
            // initImage: function() {
            //     // this.file = null
            //     this.uploadImage = {
            //         name: null,
            //         object: null,
            //         base64: null,
            //     }
            // },
        },
    }
</script>

<style scoped lang="scss">
.card {
    &.is-invalid {
        border: 1px solid #dc3545;
    }
}

.stripeError {
    font-size: 13px;
}

.flatpickrWrapper {
    input.form-control:disabled,
    input.form-control[readonly] {
        background: transparent;
    }

    input.form-control {
        &.readonly {
            background: #EAECEF;
            cursor: default;
        }
    }
}

.vc-register-title {
    margin: 25px 0 0;
    color: #434343;

    span {
        display: block;

        &:nth-child(1) {
            font-size: 18px;
        }

        &:nth-child(2) {
            margin-top: 8px;
            font-size: 28px;
        }
    }
}

.vc-campaign {
    text-align: center;

    &::after {
        content: '';
        display: block;
        width: 100px;
        border-top: 1px solid #CFD8DC;
        margin: 32px auto 38px;
    }

    .vc-campaign__meta {
        .vc-campaign__meta-title {
            color: #e91f63;
            font-size: 26px;
            text-align: center;
        }

        .vc-campaign__meta-description {
            color: #333;
        }
    }
}

.vc-intro {
    padding: 15px;
    background: #faf8ca;
    border: 1px solid rgba(0,0,0,.02);
    border-radius: 5px;
    box-sizing: border-box;
}

.vc-button-credit {
    width: 110px;
}

.vc-button-payment {
    height: 45px;
    padding-left: 18px;
    padding-right: 18px;

    &.btn-yokumiru-gray {
        cursor: not-allowed;

        &:hover {
            background: #98a6ad !important;
        }
    }
}

.termText {
    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>
